import { v4 as uuidv4 , NIL as NIL_UUID } from 'uuid';


export function newGuid(): string {
  return uuidv4();
}

export function newGuidNil(): string {
  return NIL_UUID;
}

//The canonical form of a guid for headers and comparisons: lowercase, without braces. isValidGuid accepts both,
//but the API compares the top-level org unit marker and the directory ids as text, and MSAL authorities take
//the bare form only. Call it after isValidGuid.
export function normalizeGuid(guid: string): string {
  return guid.trim().replace(/^\{|\}$/g, '').toLowerCase();
}

export function isValidGuid(guid: string | undefined): boolean {
  if (!guid) return false;
  if (!/^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/.test(guid)) {
    return false;
  }

  return true;
}
